import { render, staticRenderFns } from "./IntegrationLogs.vue?vue&type=template&id=b78bb5f6&"
import script from "./IntegrationLogs.vue?vue&type=script&lang=js&"
export * from "./IntegrationLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports